import * as React from "react";

import { cn } from "@/lib/utils";

const InputNew = React.forwardRef<
  HTMLInputElement,
  React.ComponentProps<"input">
>(({ className, type, ...props }, ref) => {
  return (
    <input
      type={type}
      className={cn(
        "flex h-10 w-full bg-[#f5f5f5] border border-t-0 border-l-0 border-r-0 rounded-none border-b-[#0d1821]/40 text-md text-[#0d1821] font-poppins pr-3 py-2 placeholder:text-[#0d1821]/70 disabled:cursor-not-allowed disabled:opacity-50 focus-visible:outline-none",
        className
      )}
      ref={ref}
      {...props}
    />
  );
});
InputNew.displayName = "InputNew";

export { InputNew };
